module.exports = __webpack_public_path__ + "img/get-more-leads.72902607.svg";